import React from "react";

const ITEMS = [
  "Bookkeeping & Accounts",
  "Tax & Advisory",
  "Payroll & HR",
  "Management Accounts",
  "Xero & QuickBooks",
  "Business Advisory",
  "Financial Operations Consultancy",
  "Free Discovery Calls",
];

export const MarqueeEditorial = () => (
  <div
    data-testid="editorial-marquee"
    className="relative py-5 sm:py-7 border-y border-[#103080]/10 bg-[#F5F2EB] overflow-hidden select-none"
    aria-hidden="true"
  >
    <div className="marquee-track items-center gap-10 sm:gap-14 pr-10 sm:pr-14">
      {[...ITEMS, ...ITEMS, ...ITEMS, ...ITEMS].map((item, i) => (
        <span key={i} className="flex items-center gap-10 sm:gap-14 shrink-0">
          <span
            className="font-sans font-bold lowercase text-xl sm:text-3xl text-[#103080] opacity-40 whitespace-nowrap"
            style={{ letterSpacing: "-0.01em" }}
          >
            {item}
          </span>
          <img
            src="/logo-mark-hd.png"
            alt=""
            aria-hidden="true"
            className="h-8 sm:h-11 w-auto shrink-0 opacity-50"
            data-testid="marquee-flower"
          />
        </span>
      ))}
    </div>
  </div>
);
